module.exports = __webpack_public_path__ + "assets/img/ZT598L-M.de3680ca.png";